import type { SellGroup, SellTreeNode, SellTreeResponse } from '@/types/sell';

// Разворачиваем дерево продаж (GET /order/tree/sale) в плоский список групп (базис + культура).
// Структура дерева идентична закупочному (см. lib/buyTree), но домен и тип группы свои. Год узла — только от сервера
// выпуска А (в UI скрыт, нужен для запроса офферов группы); узел без года (выпуск Б) — обычная группа.
export function flattenSaleTree(tree: SellTreeResponse | undefined): SellGroup[] {
  const groups: SellGroup[] = [];
  if (!tree?.nodes) {
    return groups;
  }

  const walk = (nodes: SellTreeNode[], basis?: SellTreeNode): void => {
    for (const node of nodes) {
      if (node.type === 'BASIS_ITEM') {
        walk(node.childs ?? [], node);
      } else if (node.type === 'GOODS_ITEM' && basis && node.name) {
        groups.push({
          address: basis.address ?? '',
          addressTitle: basis.addressTitle ?? basis.name ?? '',
          basisId: basis.basisId,
          goods: node.name,
          ...(node.year != null ? { year: node.year } : {}),
          updatedDate: node.updatedDate,
        });
      } else if (node.childs?.length) {
        walk(node.childs, basis);
      }
    }
  };

  walk(tree.nodes);
  return groups;
}

/** Базис со своими офферами-группами — для списка «карточка-базис → строки-культуры». */
export interface SellBasisGroup {
  readonly address: string;
  readonly addressTitle: string;
  readonly items: SellGroup[];
}

// Группировка плоского списка по базису (адрес + название). Порядок следования сохраняем
// как в дереве (бэкенд уже сортирует осмысленно).
export function groupSellByBasis(groups: readonly SellGroup[]): SellBasisGroup[] {
  const byKey = new Map<string, SellBasisGroup>();
  for (const group of groups) {
    const key = `${group.address}|${group.addressTitle}`;
    const existing = byKey.get(key);
    if (existing) {
      (existing.items as SellGroup[]).push(group);
    } else {
      byKey.set(key, { address: group.address, addressTitle: group.addressTitle, items: [group] });
    }
  }
  return [...byKey.values()];
}
